module.exports = __webpack_public_path__ + "img/3.921fd4a.jpg";